import React from 'react'
import classNames from 'classnames'
import { WemoloTypography } from '../components/Wemolo'
import styles from './enums.module.css'

export enum DeviceTypeEnum {
    SCANNER = 'PD', // All current scanners & AIoT hardware
    TERMINAL = 'TE', // Terminal
    DISPLAY = 'SC', // Screen
    ACCESS_CONTROL = 'AC', // Access control
    TRAFFIC_LIGHT = 'TL', // Traffic light
    OCCUPANCY_DISPLAY = 'OD', // Occupancy display
    MONEY_EXCHANGER = 'ME', // Money exchanger
    SWITCH_BOX = 'SB', // Switch box
    BARRIER_CONTROLLER = 'BC' // Barrier controller
}

export function getDeviceTypeEnumKey(value: string): string | undefined {
    for (const [key, enumValue] of Object.entries(DeviceTypeEnum)) {
        if (enumValue === value) {
            return key
        }
    }
    return undefined
}

const PILL_VARIANT_BY_DEVICE_TYPE: Record<string, string> = {
    SCANNER: styles.pillScanner,
    TERMINAL: styles.pillTerminal,
    DISPLAY: styles.pillDisplay,
    ACCESS_CONTROL: styles.pillAccessControl,
    TRAFFIC_LIGHT: styles.pillTrafficLight,
    OCCUPANCY_DISPLAY: styles.pillOccupancyDisplay,
    MONEY_EXCHANGER: styles.pillMoneyExchanger,
    SWITCH_BOX: styles.pillSwitchBox,
    BARRIER_CONTROLLER: styles.pillBarrierController
}

export const getPillFromDeviceType = (value: string | null | undefined): React.ReactNode => {
    if (!value) return null
    const deviceType = getDeviceTypeEnumKey(value)
    if (!deviceType) return null

    const variantClass = PILL_VARIANT_BY_DEVICE_TYPE[deviceType] ?? styles.pillDefault

    return (
        <span className={classNames(styles.pill, variantClass)}>
            <WemoloTypography variant="label-xsmall" tag="span">
                {deviceType}
            </WemoloTypography>
        </span>
    )
}
